import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ListTodo } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useClinicTasks from '../../taskmanager/useClinicTasks';

const RECEPTIONIST_ROLE = 'RECEPTIONIST';
const TODO_COLUMN_ID = 'TO_DO';
const ALERT_INTERVAL_MS = 5 * 60 * 1000;
const SESSION_KEY = 'receptionistTasksAlertLastShown';

export default function ReceptionistTasksAlert() {
  const navigate = useNavigate();
  const { tasks, fetchTasks } = useClinicTasks();

  const [showAlert, setShowAlert] = useState(false);

  const isReceptionist = useMemo(() => {
    const storedRoles = JSON.parse(sessionStorage.getItem('roles')) || [];
    return storedRoles.includes(RECEPTIONIST_ROLE);
  }, []);

  useEffect(() => {
    if (!isReceptionist) return undefined;
    fetchTasks();
    const intervalId = setInterval(fetchTasks, ALERT_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [isReceptionist, fetchTasks]);

  useEffect(() => {
    if (!isReceptionist) return;

    const hasTodoTasks = tasks.some((task) => task.columnId === TODO_COLUMN_ID);
    if (!hasTodoTasks) return;

    const lastShown = Number(sessionStorage.getItem(SESSION_KEY));
    const now = Date.now();
    if (!lastShown || now - lastShown >= ALERT_INTERVAL_MS) {
      setShowAlert(true);
      sessionStorage.setItem(SESSION_KEY, String(now));
    }
  }, [tasks, isReceptionist]);

  if (!isReceptionist) return null;

  const todoCount = tasks.filter((task) => task.columnId === TODO_COLUMN_ID).length;

  return (
    <Modal
      show={showAlert}
      onHide={() => setShowAlert(false)}
      centered
      data-cy="receptionist-tasks-alert-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <ListTodo className="text-primary" size={24} />
          Tarefas pendentes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          Você tem{' '}
          <strong>{todoCount === 1 ? '1 tarefa a fazer' : `${todoCount} tarefas a fazer`}</strong>.
        </p>
        <p className="mb-0 text-muted">
          Por favor, execute as tarefas pendentes o quanto antes para manter o dia da clínica em
          dia.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => setShowAlert(false)}>
          Fechar
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            setShowAlert(false);
            navigate('/tasks');
          }}
        >
          Ver tarefas
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
